import { Box, H3 } from '@ouster/webviz-react-components';

export default function ScreenRecommendation() {
  return (
    <Box maxW="85vw" display="grid" rowGap="1.5rem" data-testid="screen-recommendation-root">
      <H3 mb="1rem">Best Viewed on Desktop</H3>
      <p style={{ lineHeight: 1.5 }}>
        Our platform is designed to provide the best experience on a desktop or
        laptop. Unfortunately, the features and functionalities may not work as
        expected on smaller screens.
      </p>
      <p style={{ lineHeight: 1.5 }}>
        For the optimal experience, we recommend accessing our platform on a
        desktop or laptop. Please revisit this page on a larger screen to take
        full advantage of everything we offer.
      </p>
      <p style={{ lineHeight: 1.5 }}>
        If you have any questions or need assistance, feel free to contact our
        support team.
      </p>
    </Box>
  );
}
